import { useFormik } from "formik";
import { useExportToDoc } from 'html-to-doc-react';
import html2pdf from "html2pdf.js";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { usePDF } from "react-to-pdf";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { customStyles } from "../../../../core/common/Custom Style/CustomStyle";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import ModalComponent from "../../../../core/common/modal/ModalComponent";
import RichTextEditor from "../../../../core/common/Rich Text Editor/RichTextEditor";
import TextField from "../../../../core/common/textFields/TextField";
import {
  useGetAllAddendaQuery,
  useGetApptConfirmationQuery,
  useGetFirstAptTicketQuery,
  useGetjobCardQuery,
  useGetprintoutPdfDetailsQuery,
  useLazyGetAddendaAgreementQuery,
  useLazyGetSaleInfoByIdQuery,
  useLazyGetTeamMembersEmailQuery,
  useSendEmailMutation
} from "../../../../services/EndPointsApis";
import AddendaCard from "./download to pdf/AddendaCard";
import ApptConfirmationLetter from "./download to pdf/ApptConfirmationLetter";
import FirstAptTicket from "./download to pdf/FirstAptTicket";
import JobCard from "./download to pdf/JobCard";

const PrintOutTab = ({ projectId, projectLookups }: any) => {
  const { toPDF, targetRef } = usePDF({
    filename: "FirstAppointmentTicket.pdf",
  });
  const { toPDF: toPDFJob, targetRef: targetRefJob } = usePDF({
    filename: "Job Card.pdf",
  });
  const [addendaId, setAddendaId] = useState({});
  const [showAddenda, setShowAddenda] = useState(false);
  const [showAptTicket, setShowAptTicket] = useState(false);
  const [showJobCard, setShowjobCard] = useState(false);
  const [showClientApt, setShowClientApt] = useState(false);
  const [showAcceptancePlans, setShowAcceptancPlans] = useState(false);


  const [ispdfLoading, setPdfIsLoading] = useState(false);
  const [isFirstAptLoading, setIsFirstAptLoading] = useState(false);
  const [isConfirmLetterLoading, setIsConfirmLetterLoading] = useState(false);

  const [isJobCardLoading, setIsJobCardLoading] = useState(false);

  const exportToDoc = useExportToDoc();

  const { data: getFirstAptTicket, refetch: refetchAptTicket } =
    useGetFirstAptTicketQuery({ projectId });
  const { data: getjobCard, refetch: refetchJobCard } = useGetjobCardQuery({
    projectId,
  });


  //all addenda
  const {
    data: allAddenda,
    isLoading,
    refetch,
  } = useGetAllAddendaQuery({ ProjectId: projectId });
  //Addenda data
  const [triggerAddenda, { data: addendaData, isFetching: isFetchingPdf }] =
    useLazyGetAddendaAgreementQuery();
  //client appt confirmation
  const { data: apptConfirmationData, refetch: refetchAptConfirm } =
    useGetApptConfirmationQuery({ ProjectId: projectId });

  const { data: printOutPdfDetails, refetch: refetchPrintOutPdf } =
    useGetprintoutPdfDetailsQuery({ ProjectId: projectId });

  const [triggerSaleInfo, { data: saleInfoData }] = useLazyGetSaleInfoByIdQuery()

  // const { toPDF: toPDFAddenda, targetRef: targetAddenda } = usePDF({

  //   filename: 'Addenda Addition.pdf',
  //   page: {
  //     margin: Margin.MEDIUM, // or a specific number like 10
  //     format: 'a4', // Format options like 'a4', 'letter', etc.
  //     orientation: 'portrait', // or 'landscape'
  //   },
  // });

  const handleDownload = async () => {
    setIsFirstAptLoading(true);
    try {
      await toPDF?.();
      setShowAptTicket(false);
    } catch (error) {
    } finally {
      setIsFirstAptLoading(false);
    }
  };
  const printRefFirstApt = useRef(null);
  const [shouldPrintFirstApt, setShouldPrintFirstApt] = useState(false);

  const handlePrintFApt = useReactToPrint({
    content: () => printRefFirstApt.current,
  });
  const handlePrintFirstApt = () => {
    setShouldPrintFirstApt(true);
    refetchAptTicket();
  };
  const handleFirstAptReady = () => {
    if (shouldPrintFirstApt) {
      handlePrintFApt();
      setShouldPrintFirstApt(false);
    }
  };

  const handleDownloadJob = async () => {
    setIsJobCardLoading(true);
    try {
      await toPDFJob?.();
      setShowjobCard(false);
    } catch (error) {
    } finally {
      setIsJobCardLoading(false);
    }
  };
  const [shouldPrintJobCard, setShouldPrintJobCard] = useState(false);
  const printRefJobCard = useRef(null);

  const handlePrintJC = useReactToPrint({
    content: () => printRefJobCard.current,
  });

  const handlePrintJobCard = () => {
    setShouldPrintJobCard(true);
    refetchJobCard();
  };

  const handleJobCardReady = () => {
    if (shouldPrintJobCard) {
      handlePrintJC();
      setShouldPrintJobCard(false);
    }
  };

  const downloadPDF = async (item: any) => {
    const dynamicFileName = `${item?.addendaNbr || "default"
      }.pdf`;
    const content = document.getElementById("pdf-content");
    if (!content) {
      setPdfIsLoading(false);
      return;
    }
    const options = {
      margin: 0,
      filename: dynamicFileName,
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    setPdfIsLoading(true);
    try {
      await html2pdf().set(options).from(content).save();
      setShowAddenda(false);
    } catch (error) {
    } finally {
      setPdfIsLoading(false);
    }
  };

  const downloadConfirmLetter = async () => {
    const content = document.getElementById("appt-Confirmation");
    const options = {
      margin: 0,
      filename: "Client Appt Confirmation Letter.pdf",
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    setIsConfirmLetterLoading(true);
    try {
      await html2pdf().set(options).from(content).save();
      setShowClientApt(false);
    } catch (error) {
    } finally {
      setIsConfirmLetterLoading(false);
    }
  };

  //acceptance of plans code for direct print and pdf download and sendEmail



  const [filteredData, setFilteredData] = useState<
    { addendaNbr: string; status: string; id: string; downloadHandler: () => void }[]
  >([]);

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const filteredAndMappedData = allAddenda?.result?.approvedAndReviewd
      ?.filter((item: any) => item?.status === "Approved")
      ?.map((item: any) => ({
        addendaNbr: item?.addendaNbr,
        id: item?.id,
        status: item?.status,
        // downloadHandler: () => downloadPDF(item),
        showAddenda: () => handleShowAddenda(item),
      }));
    setFilteredData(filteredAndMappedData);
  }, [allAddenda]);

  useEffect(() => {
    refetchAptTicket();
    refetchJobCard();
    refetch();
    refetchAptConfirm();
  }, []);

  const allData = [
    {
      name: "First Appointment Ticket",
      type: "Lead",
      downloadHandler: handleDownload,
    },
    { name: "Job Card", type: "Project", downloadHandler: handleDownloadJob },
    {
      name: "Client Appt Confirmation Letter",
      type: "addenda",
      downloadHandler: downloadPDF,
    },
  ];

  const handleCloseAddenda = () => {
    setShowAddenda(false);
  };
  const handleShowAddenda = (item: any) => {
    setAddendaId(item);
    setShowAddenda(true);
    triggerSaleInfo({ ProjectId: projectId });
    triggerAddenda({ ProjectId: projectId, AddendaId: item.id });
  };
  const handleCloseFirstAptTicket = () => {
    setShowAptTicket(false);
  };
  const handleShowFirstAptTicket = (item: any) => {
    setShowAptTicket(true);
  };
  const handleClosejobCard = () => {
    setShowjobCard(false);
  };
  const handleShowjobCard = (item: any) => {
    setShowjobCard(true);
  };
  const handleCloseClientApt = () => {
    setShowClientApt(false);
  };
  const handleShowClientApt = (item: any) => {
    setShowClientApt(true);
  };




  //email code

  const [showModal, setShowModal] = useState(false);
  const [modalTitlePopup, setModalTitlePopup] = useState("");
  const [noteDescription, setNoteDescription] = useState("");

  //email api
  const [sendEmail, { data, isSuccess }] = useSendEmailMutation();
  //getTeam Member Email
  const [
    triggerTeamsMember,
    { data: getTeamMembers, isSuccess: isSuccessEmail, isFetching },
  ] = useLazyGetTeamMembersEmailQuery();

  const [emails, setEmails] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [fileData, setFileData] = useState<File[]>([]);

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const decodeHtml = (html: any) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      const email = inputValue.trim();

      if (
        isValidEmail(email) &&
        !formik.values.ExternalEmailAddresses.includes(email)
      ) {
        formik.setFieldValue("ExternalEmailAddresses", [
          ...formik.values.ExternalEmailAddresses.filter(
            (email: string) => email !== ""
          ),
          email,
        ]);
        setInputValue("");
      }
    }
  };
  const removeEmail = (email: string) => {
    const filteredEmails = formik.values.ExternalEmailAddresses.filter(
      (e: string) => e !== email
    );
    formik.setFieldValue("ExternalEmailAddresses", filteredEmails);
  };
  const handleClose = () => {
    setShowModal(false);
    formik.resetForm();
  };

  const handleSave = () => {
    formik.handleSubmit();
  };
  const handleGetTeamMembers = () => {
    triggerTeamsMember({ projectId: projectId });
  };

  const ValidationSchema = Yup.object().shape({
    Subject: Yup.string().required("Subject is required"),
    InternalEmailAddresses: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.number()
            .min(1, "Internal User required")
            .required("Internal User required"),
        })
      )
  });

  const initialValues = {
    Subject: "",
    InternalEmailAddresses: [
      {
        id: 0,
        value: "",
      },
    ],
    ExternalEmailAddresses: [""],
    Body: "",
    Attachments: [] as { name: string; data: ArrayBuffer }[],
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ValidationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("Subject", values.Subject);
      formData.append(
        "InternalEmailAddresses",
        values.InternalEmailAddresses.map((item) => item.value).toString()
      );
      formData.append(
        "ExternalEmailAddresses",
        values.ExternalEmailAddresses.toString()
      );
      formData.append("Body", values.Body);
      values.Attachments.forEach(({ name, data }, index) => {
        const fileBlob = new Blob([data], { type: "application/pdf" });
        formData.append(`Attachments`, fileBlob, name);
      });
      try {
        await sendEmail(formData).unwrap();
        toast.success("Email Sent successfully");
        formik.resetForm();
        setShowModal(false);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },
  });

  const selectValues = formik.values?.InternalEmailAddresses
    ? formik.values.InternalEmailAddresses.filter(
      (users: { id: number; value: string }) =>
        users.id !== 0 && users.value !== ""
    ).map((users: { id: number; value: string }) => ({
      value: users?.id,
      label: users?.value,
    }))
    : [];

  const handleChange = (newValue: any) => {
    const updatedValues = newValue.map(
      (option: { value: any; label: any }) => ({
        id: option.value,
        value: option.label,
      })
    );

    formik.setFieldValue("InternalEmailAddresses", updatedValues);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      setFileData(fileArray);
      formik.setFieldValue("Attachments", fileArray);
    }
  };

  useEffect(() => {
    if (!isFetching && getTeamMembers?.result) {
      console.log(getTeamMembers);

      const mappedMembers = getTeamMembers.result.map((member: any) => ({
        id: member.id,
        value: member.value,
      }));

      setEmails(mappedMembers);
      formik.setFieldValue("InternalEmailAddresses", mappedMembers);
    }
  }, [isFetching, getTeamMembers]);

  //handle function to setfile directly in the attachment

  const handleGeneratePDFAptConfm = async () => {
    const content = document.getElementById("appt-Confirmation");
    if (!content) {
      console.error("Element not found:", "appt-Confirmation");
      return;
    }

    const options = {
      margin: 0,
      filename: "Client_Appointment_Confirmation_Letter.pdf",
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      console.log("Generating PDF...");
      const pdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .output("blob");
      console.log("PDF Blob created successfully");
      console.log("ArrayBuffer:", pdfBlob);

      const arrayBuffer = await pdfBlob.arrayBuffer();
      formik.setFieldValue("Attachments", [
        { name: "Appointment_Confirmation_Letter.pdf", data: arrayBuffer },
      ]);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleGeneratePDFAddenda = async (item: any) => {
    const content = document.getElementById("pdf-content");
    if (!content) {
      console.error("Element not found:", "pdf-content");
      return;
    }

    const options = {
      margin: 0,
      filename: `${item?.addendaNbr}.pdf`,
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      console.log("Generating PDF...");
      const pdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .output("blob");
      console.log("PDF Blob created successfully");

      // Convert Blob to ArrayBuffer
      const arrayBuffer = await pdfBlob.arrayBuffer();
      // Update Formik field
      formik.setFieldValue("Attachments", [
        { name: `${item?.addendaNbr}.pdf`, data: arrayBuffer },
      ]);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleGeneratePDFJobCard = async () => {
    const content = document.getElementById("job-card");
    if (!content) {
      console.error("Element not found:", "job-card");
      return;
    }

    const options = {
      margin: 0,
      filename: `Job Card.pdf`,
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      console.log("Generating PDF...");
      const pdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .output("blob");
      console.log("PDF Blob created successfully");

      // Convert Blob to ArrayBuffer
      const arrayBuffer = await pdfBlob.arrayBuffer();
      // Update Formik field
      formik.setFieldValue("Attachments", [
        { name: `Job Card.pdf`, data: arrayBuffer },
      ]);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleGeneratePDFfirstApt = async () => {
    const content = document.getElementById("fist_Apt_Ticket");
    if (!content) {
      console.error("Element not found:", "fist_Apt_Ticket");
      return;
    }

    const options = {
      margin: 0,
      filename: `First_Appointment_Ticket.pdf`,
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      console.log("Generating PDF...");
      const pdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .output("blob");
      console.log("PDF Blob created successfully");

      // Convert Blob to ArrayBuffer
      const arrayBuffer = await pdfBlob.arrayBuffer();
      // Update Formik field
      formik.setFieldValue("Attachments", [
        { name: `First_Appointment_Ticket.pdf`, data: arrayBuffer },
      ]);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };


  const handleEmailFstAppT = () => {
    setModalTitlePopup("First Appointment Email");
    setShowModal(true);
    setShowAptTicket(false);
    handleGeneratePDFfirstApt();
  };

  const handleEmailJobCard = () => {
    setModalTitlePopup("Job Card Email");
    setShowModal(true);
    setShowjobCard(false);
    handleGeneratePDFJobCard();
  };
  const handleEmailClientApt = () => {
    setModalTitlePopup("Client Appointment Email");
    setShowModal(true);
    setShowClientApt(false);
    handleGeneratePDFAptConfm();
  };
  const handleEmailAddenda = (item: any) => {
    setModalTitlePopup(`${item.addendaNbr} Addenda Email`);
    setShowModal(true);
    setShowAddenda(false);
    handleGeneratePDFAddenda(item);
  };


  //code for direct print 

  const [isRenderReady, setIsRenderReady] = useState(false);
  const [shouldPrint, setShouldPrint] = useState(false);
  const [addendaIdForPdf, setAddendaIdForPdf] = useState(null);

  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  } as any);



  const handlePrintWithData = (item: any) => {
    setAddendaIdForPdf(item);
    setShouldPrint(true);
    setIsRenderReady(false);
    triggerAddenda({ ProjectId: projectId, AddendaId: item.id });
    triggerSaleInfo({ ProjectId: projectId })
  };
  const [addendaDataForPdf, setAddendaDataForPdf] = useState<any>(null);
  const [saleInfoDataForPdf, setSaleInfoDataForPdf] = useState<any>(null);

  useEffect(() => {
    if (addendaData?.result && saleInfoData?.result) {
      setAddendaDataForPdf(addendaData);
      setSaleInfoDataForPdf(saleInfoData)
    }
  }, [addendaData, saleInfoData]);

  useEffect(() => {
    if (shouldPrint && isRenderReady) {
      setTimeout(() => {
        handlePrint();
        setShouldPrint(false);
      }, 150);
    }
  }, [shouldPrint, isRenderReady]);


  //multiple print

  const [isPrinting, setIsPrinting] = useState(false);
  const [selectedAddendaIds, setSelectedAddendaIds] = useState<string[]>([]);
  const [addendaDataMap, setAddendaDataMap] = useState<{ [id: string]: any }>({});

  const [selected, setSelected] = useState({
    apt: false,
    jobcard: false,
    addenda: false,
  });

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setSelected(prev => ({ ...prev, [name]: checked }));
  };

  const handleCheckAddenda = (id: string, addendaNbr: string) => {

    setSelectedAddendaIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const fetchAddendaData = async (id: string) => {
    try {
      const result = await triggerAddenda({
        ProjectId: projectId,
        AddendaId: id
      }).unwrap();

      setAddendaDataMap(prev => ({
        ...prev,
        [id]: result
      }));
    } catch (err) {
      console.error("Failed to fetch addenda:", err);
    }
  };

  useEffect(() => {
    selectedAddendaIds.forEach(id => {
      if (!addendaDataMap[id]) {
        fetchAddendaData(id);
      }
    });
  }, [selectedAddendaIds]);

  useEffect(() => {
    triggerSaleInfo({ ProjectId: projectId });
  }, [])


  // const downloadPDFMulti = async () => {
  //   const content = document.getElementById("pdf-multi-container");
  //   if (!content) return;
  //   setIsPrinting(true)
  //   const options = {
  //     margin: 0,
  //     filename: "multi-component.pdf",
  //     html2canvas: { scale: 5 },
  //     jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //   };

  //   try {
  //     const pdf = html2pdf().set(options).from(content);
  //     // Instead of save(), generate a blob URL
  //     const blobUrl = await pdf.output('bloburl');
  //     // Open in new window
  //     window.open(blobUrl, "_blank");
  //   } catch (error) {
  //     console.error(error);
  //   }
  //   finally {
  //     setIsPrinting(false)
  //     setSelectedAddendaIds([])
  //     setSelected({
  //       apt: false,
  //       jobcard: false,
  //       addenda: false,
  //     })
  //   }
  // };

  const printRefMulti = useRef<HTMLDivElement>(null);

  const downloadPDFMulti = useReactToPrint({
    content: () => printRefMulti.current,
    documentTitle: "multi-component",
    onAfterPrint: () => {
      setSelectedAddendaIds([]);
      setSelected({
        apt: false,
        jobcard: false,
        addenda: false,
      });
    },
  });

  return (
    <>
      <ModalComponent
        buttonText="Send"
        modalTitle={modalTitlePopup}
        onClose={handleClose}
        onSave={handleSave}
        isVisible={showModal}
        cancelButton="Cancel"
        saveButton="Send"
      >
        <>
          <div className="row">
            <div className="col-md-12">
              <div className="input-label">
                <TextField
                  label="Subject"
                  required
                  type="text"
                  {...formik.getFieldProps("Subject")}
                />
              </div>
              {formik.touched.Subject && formik.errors.Subject && (
                <>
                  <div className="error">{formik.errors.Subject}</div>
                </>
              )}
              <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center">
                  <label>Internal Users</label>
                  <button
                    className="btn btn-primary mb-1 mt-1 fs-11"
                    onClick={handleGetTeamMembers}
                  >
                    Get Team Members
                  </button>
                </div>
                <Select
                  isMulti={true}
                  styles={customStyles}
                  className="select multi-select"
                  options={
                    projectLookups?.result?.ActiveUserEmail?.map(
                      (option: any) => ({
                        label: option?.value,
                        value: option?.id,
                      })
                    ) || []
                  }
                  value={selectValues}
                  onChange={(newValue: any) => handleChange(newValue)}
                />
              </div>
              {Array.isArray(formik.errors.InternalEmailAddresses) &&
                formik.errors.InternalEmailAddresses.map((error, index) => {
                  const fieldTouched =
                    formik.touched.InternalEmailAddresses?.[index];
                  const isObjectError =
                    typeof error === "object" && error !== null;

                  return (
                    <div key={index}>
                      {isObjectError && fieldTouched?.id && error.id && (
                        <div className="error">{error.id}</div>
                      )}
                      {isObjectError && fieldTouched?.value && error.value && (
                        <div className="error">{error.value}</div>
                      )}
                    </div>
                  );
                })}
              <div className="col-md-12">
                <div className="d-flex justify-content-between">
                  <label className="input-label">External Users</label>
                </div>
                <div className="email-input-container">
                  <div className="badges-container">
                    {formik.values.ExternalEmailAddresses[0] !== "" ? (
                      formik.values.ExternalEmailAddresses.map(
                        (email: string, index: number) => (
                          <span
                            key={index}
                            className="badge badge-pill badge-primary me-2"
                          >
                            {email}{" "}
                            <button
                              type="button"
                              className="btn-close ms-1"
                              onClick={() => removeEmail(email)}
                            >
                              &times;
                            </button>
                          </span>
                        )
                      )
                    ) : (
                      <span className="text-muted"></span>
                    )}
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter email and Press enter"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  {formik.errors.ExternalEmailAddresses && (
                    <div className="text-danger">
                      {formik.errors.ExternalEmailAddresses}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <RichTextEditor
                  value={formik.values.Body}
                  name="Message"
                  onChange={(value: any) => formik.setFieldValue("Body", value)}
                />
              </div>
              {/* <div className='col-md-12'>
                <div className='d-flex flex-column'>
                  <label className='input-label'> Attachments</label>
                  <input type="file" className=''
                    onChange={(event) => {
                      const file = event.currentTarget.files?.[0];
                      if (file) {
                        file.arrayBuffer().then((arrayBuffer) => {
                          formik.setFieldValue("Attachments", [{ name: file.name, data: arrayBuffer }]);
                        });
                      }
                    }}
                    id="file"
                    name="file"
                    accept=".png, .jpg, .jpeg, .pdf"
                  />
                  {formik.values.Attachments.length > 0 && (
                    <p>Selected File: {formik.values.Attachments[0].name}</p>
                  )}
                </div>
              </div> */}
              <label className="input-label mt-2"> Attachments</label>
              <div className="br-gray p-2 bg-lightGray">
                <p>{formik.values.Attachments[0]?.name}</p>
              </div>
            </div>
          </div>
        </>
      </ModalComponent>

      <ModalComponent
        modalTitle={`Addenda Addition`}
        isVisible={showAddenda}
        cancelButton="Cancel"
        buttonText2="Send Email"
        onSave2={() => handleEmailAddenda(addendaId)}
        onClose={handleCloseAddenda}
        saveButton={ispdfLoading ? "Downloading..." : "Download"}
        className="p-2 modal-xl"
        onSave={() => downloadPDF(addendaId)}
      >
        <AddendaCard
          addendaData={addendaData}
          addendaId={addendaId}
          projectId={projectId}
          saleInfoDataForPdf={saleInfoData}
        />
      </ModalComponent>

      <div style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}>
        {addendaIdForPdf && addendaDataForPdf && (
          <AddendaCard addendaId={addendaIdForPdf} projectId={projectId} printRef={printRef}
            onRenderReady={() => setIsRenderReady(true)} saleInfoDataForPdf={saleInfoDataForPdf}
            addendaData={addendaDataForPdf} />
        )}
      </div>
      <ModalComponent
        modalTitle="First Apt Ticket"
        isVisible={showAptTicket}
        cancelButton="Cancel"
        buttonText2="Send Email"
        onClose={handleCloseFirstAptTicket}
        onSave2={handleEmailFstAppT}
        saveButton={isFirstAptLoading ? "Downloading..." : "Download"}
        className="p-2 modal-xl"
        onSave={() => handleDownload()}
      >
        <FirstAptTicket
          getFirstAptTicket={getFirstAptTicket}
          targetRef={targetRef}
        />
      </ModalComponent>

      <div
        ref={printRefFirstApt}
        className="job-card-print"
        style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
      >
        {getFirstAptTicket?.result && shouldPrintFirstApt && (
          <FirstAptTicket
            getFirstAptTicket={getFirstAptTicket}
            targetRef={printRefFirstApt}
            onRenderReady={handleFirstAptReady}
          />
        )}
      </div>

      <ModalComponent
        modalTitle="Job Card"
        isVisible={showJobCard}
        cancelButton="Cancel"
        onClose={handleClosejobCard}
        buttonText2="Send Email"
        onSave2={handleEmailJobCard}
        saveButton={"Download"}
        className="p-2 modal-xl"
        onSave={() => handleDownloadJob()}
      >
        <JobCard getjobCard={getjobCard} targetRef={targetRefJob} projectId={projectId} />
      </ModalComponent>
      <div
        ref={printRefJobCard}
        style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
      >
        {getjobCard?.result && shouldPrintJobCard && (
          <JobCard getjobCard={getjobCard} targetRef={printRefJobCard} onRenderReady={handleJobCardReady} projectId={projectId} />
        )}
      </div>
      <ModalComponent
        modalTitle="Client Confirmation Letter"
        isVisible={showClientApt}
        cancelButton="Close"
        onClose={handleCloseClientApt}
        buttonText2="Send Email"
        onSave2={handleEmailClientApt}
        saveButton={isConfirmLetterLoading ? "Downloading..." : "Download"}
        className="p-2 modal-xl"
        onSave={() => downloadConfirmLetter()}
      >
        <ApptConfirmationLetter apptConfirmationData={apptConfirmationData} />
      </ModalComponent>
      <div style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}>
        <div id="pdf-multi-container" ref={printRefMulti}>
          {selected.apt && <FirstAptTicket
            getFirstAptTicket={getFirstAptTicket}
            targetRef={printRefFirstApt}
            onRenderReady={handleFirstAptReady}
          />
          }
          {selected.jobcard && <JobCard getjobCard={getjobCard} targetRef={targetRefJob} projectId={projectId} />
          }
          {selectedAddendaIds.map((id) =>
            addendaDataMap[id] && saleInfoData?.result ? (
              <AddendaCard
                key={id}
                addendaId={id}
                projectId={projectId}
                printRef={printRef}
                saleInfoDataForPdf={saleInfoData}
                addendaData={addendaDataMap[id]}
                onRenderReady={() => setIsRenderReady(true)}
              />
            ) : null
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-7">
          <div className="card">
            <div className="card-body card-css">
              <h6>
                The Link Below represents printouts available in different
                places in AFD. Use this page to quickly locate and print
                printouts of all kinds.
              </h6>
              {((selected.jobcard || selected.apt) || (selectedAddendaIds.length > 0)) &&
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    className="btn btn-primary"
                    data-tooltip-id="my-tooltip-5"
                    onClick={downloadPDFMulti}
                    disabled={(selectedAddendaIds.length > 2 && (selected.jobcard || selected.apt)) || (selectedAddendaIds.length > 3 && (!selected.jobcard || !selected.apt))}
                  >
                    {isPrinting ? "Printing....." : "Print"}
                  </button>
                </div>
              }
              {/* <input
                type="text"
                className="form-control my-3"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              /> */}
              <div className="table-responsive mt-3">
                <table className="table datanew dataTable no-footer table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>TYPE</th>
                      <th>Print</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <label className="checkboxs mb-3">
                          <input type="checkbox" name="apt" checked={selected.apt} onChange={handleCheck} />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td
                        className="text-decoration-underline color-red cursor-pointer mb-0"
                        onClick={handleShowFirstAptTicket}
                      >
                        First Appointment Ticket
                      </td>
                      <td>Lead</td>
                      <td
                        className="cursor-pointer"
                        onClick={handlePrintFirstApt}
                      >
                        {!shouldPrintFirstApt ?
                          <button
                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                            data-tooltip-id="my-tooltip-5">
                            <ImageWithBasePath
                              src="assets/img/printIcon.svg"
                              className=""
                              alt="Logo"
                              width={16}
                              height={16}
                            />
                          </button>
                          :
                          <div className="spinnerPdf" />
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="checkboxs mb-3">
                          <input type="checkbox" name="jobcard" checked={selected.jobcard} onChange={handleCheck} />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td
                        className="text-decoration-underline color-red cursor-pointer mb-0"
                        onClick={handleShowjobCard}
                      >
                        Job Card
                      </td>
                      <td>Project</td>
                      <td
                        className="cursor-pointer"
                        onClick={handlePrintJobCard}
                      >
                        {!shouldPrintJobCard ?
                          <button
                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                            data-tooltip-id="my-tooltip-5">
                            <ImageWithBasePath
                              src="assets/img/printIcon.svg"
                              className=""
                              alt="Logo"
                              width={16}
                              height={16}
                            />
                          </button>
                          :
                          <div className="spinnerPdf" />
                        }
                      </td>
                      {/* <td className='text-center cursor-pointer' onClick={handleEmailJobCard}>
                        {svgIcons.email}
                      </td> */}
                    </tr>
                    {/* <tr>
                      <td
                        className="text-decoration-underline color-red cursor-pointer mb-0"
                        onClick={handleShowClientApt}
                      >
                        Client Appt Confirmation letter
                      </td>
                      <td>Lead</td>
                    </tr> */}

                    {filteredData?.map((item: any, index: any) => (
                      <tr key={index}>
                        <td>
                          <label className="checkboxs mb-3">
                            <input
                              type="checkbox"
                              checked={selectedAddendaIds?.includes(item.id)}
                              onChange={() => handleCheckAddenda(item.id, item?.addendaNbr)}
                            />
                            <span className="checkmarks" />
                          </label>
                        </td>
                        <td
                          className="text-decoration-underline color-red cursor-pointer mb-0"
                          onClick={item.showAddenda}
                        >
                          {item.addendaNbr}
                        </td>
                        <td>Addenda</td>
                        <td
                          className="cursor-pointer"
                          // onClick={() => handleShowAddenda(data)}
                          onClick={() => handlePrintWithData(item)}
                        >
                          {/* {!isFetchingPdf ? */}
                          <button
                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                            data-tooltip-id="my-tooltip-5">
                            <ImageWithBasePath
                              src="assets/img/printIcon.svg"
                              className=""
                              alt="Logo"
                              width={16}
                              height={16}
                            />
                          </button>
                          {/* :
                            <div className="spinnerPdf" /> */}
                          {/* } */}

                        </td>

                        {/* <td className='text-center cursor-pointer' onClick={() => handleEmailAddenda(item)}>
                          {svgIcons.email}
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrintOutTab;
